/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="11.93"
        height="6.68"
        viewBox="0 0 11.93 6.68"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <polygon
          points="11.93 0.73 11.22 0.02 6 5.27 0.7 0 0 0.71 6 6.68 11.93 0.73"
          className="icon-fill"/>
      </svg>

    );
  }
}

Icon.displayName = 'ChevronDownIcon';

export default Icon;
